import { useQuery } from '@hooks/reactQuery';

import { getTechnologies } from '@api/manageSite';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TECHNOLOGIES } from '@constants/queryKeys';

export function useTechnologies() {
	const { data: technologies, isFetching } = useQuery({
		queryKey: [TECHNOLOGIES],
		queryFn: extractQueryParams(getTechnologies),
		refetchOnWindowFocus: false,
	});

	return {
		technologies,
		technologiesOptions: optionsFormatted(technologies || []),
		isLoading: isFetching,
	};
}
